"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _theme = require("@zip/theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgSuccess = function SvgSuccess(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var theme = (0, _react.useTheme)();

  switch (theme.name) {
    case _theme.fearlessBusiness.name:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 110 100",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.35 66.94H4.336a1.612 1.612 0 110-3.227h7.012c.892 0 1.613.721 1.613 1.613s-.72 1.613-1.613 1.613z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "success_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 59,
          y: 96,
          width: 12,
          height: 4,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.945 96.41h10.24v3.226h-10.24v-3.225z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#success_svg__a)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M68.571 99.637h-7.013a1.612 1.612 0 110-3.226h7.013c.892 0 1.613.72 1.613 1.613 0 .892-.72 1.613-1.613 1.613z",
            fill: "#D0EEFD"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.625 72.387H1.613a1.612 1.612 0 110-3.225h7.012a1.611 1.611 0 110 3.226z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "success_svg__b",
          maskUnits: "userSpaceOnUse",
          x: 96,
          y: 1,
          width: 13,
          height: 13,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M96.475 1.614h11.799v11.798h-11.8V1.614z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#success_svg__b)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M106.662 5.9h-2.674V3.228c0-.892-.721-1.613-1.613-1.613s-1.613.72-1.613 1.613V5.9h-2.674c-.892 0-1.613.72-1.613 1.613 0 .892.72 1.613 1.613 1.613h2.674v2.672c0 .892.721 1.613 1.613 1.613s1.613-.72 1.613-1.613V9.127h2.674c.892 0 1.613-.721 1.613-1.613s-.721-1.613-1.613-1.613z",
            fill: "#D0EEFD"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M82.8 46.48c0 16.053-13.012 29.066-29.065 29.066-16.054 0-29.065-13.013-29.065-29.066 0-16.051 13.011-29.066 29.065-29.066 16.053 0 29.066 13.014 29.066 29.066z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M58.87 14.044c-15.137 0-27.453 12.316-27.453 27.453 0 15.136 12.316 27.452 27.453 27.452 15.137 0 27.453-12.316 27.453-27.452 0-15.137-12.316-27.453-27.453-27.453zm0 58.13c-16.916 0-30.679-13.76-30.679-30.677s13.763-30.679 30.68-30.679c16.915 0 30.678 13.762 30.678 30.68 0 16.916-13.763 30.677-30.679 30.677z",
          fill: "#124099"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M55.017 50.816c-.413 0-.825-.158-1.14-.472l-7.706-7.707a1.61 1.61 0 010-2.28 1.61 1.61 0 012.28 0l6.566 6.566 14.275-14.274a1.614 1.614 0 012.28 0c.63.63.63 1.651 0 2.28L56.158 50.344a1.608 1.608 0 01-1.14.472z",
          fill: "#124099"
        })]
      }));

    default:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 110 100",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.35 66.94H4.336a1.612 1.612 0 110-3.227h7.012c.892 0 1.613.721 1.613 1.613s-.72 1.613-1.613 1.613z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "success_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 59,
          y: 96,
          width: 12,
          height: 4,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.945 96.41h10.24v3.226h-10.24v-3.225z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#success_svg__a)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M68.571 99.637h-7.013a1.612 1.612 0 110-3.226h7.013c.892 0 1.613.72 1.613 1.613 0 .892-.72 1.613-1.613 1.613z",
            fill: "#EDE6FF"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.625 72.387H1.613a1.612 1.612 0 110-3.225h7.012a1.611 1.611 0 110 3.226z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "success_svg__b",
          maskUnits: "userSpaceOnUse",
          x: 96,
          y: 1,
          width: 13,
          height: 13,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M96.475 1.614h11.799v11.798h-11.8V1.614z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#success_svg__b)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M106.662 5.9h-2.674V3.228c0-.892-.721-1.613-1.613-1.613s-1.613.72-1.613 1.613V5.9h-2.674c-.892 0-1.613.72-1.613 1.613 0 .892.72 1.613 1.613 1.613h2.674v2.672c0 .892.721 1.613 1.613 1.613s1.613-.72 1.613-1.613V9.127h2.674c.892 0 1.613-.721 1.613-1.613s-.721-1.613-1.613-1.613z",
            fill: "#EDE6FF"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M82.8 46.48c0 16.053-13.012 29.066-29.065 29.066-16.054 0-29.065-13.013-29.065-29.066 0-16.051 13.011-29.066 29.065-29.066 16.053 0 29.066 13.014 29.066 29.066z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M58.87 14.044c-15.137 0-27.453 12.316-27.453 27.453 0 15.136 12.316 27.452 27.453 27.452 15.137 0 27.453-12.316 27.453-27.452 0-15.137-12.316-27.453-27.453-27.453zm0 58.13c-16.916 0-30.679-13.76-30.679-30.677s13.763-30.679 30.68-30.679c16.915 0 30.678 13.762 30.678 30.68 0 16.916-13.763 30.677-30.679 30.677z",
          fill: "#6542BE"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M55.017 50.816c-.413 0-.825-.158-1.14-.472l-7.706-7.707a1.61 1.61 0 010-2.28 1.61 1.61 0 012.28 0l6.566 6.566 14.275-14.274a1.614 1.614 0 012.28 0c.63.63.63 1.651 0 2.28L56.158 50.344a1.608 1.608 0 01-1.14.472z",
          fill: "#6542BE"
        })]
      }));
  }
};

var _default = SvgSuccess;
exports["default"] = _default;